export default "assets/images/icons/facebook-c11d1440.svg";